import fetchJSON from '@api/api_helper';

const url = ({ resourceKey, resourceType }) => (
  `/api/v4/${resourceType}s/${resourceKey}/share_manifests`
);

export const create = ({
  key: resourceKey,
  type: resourceType,
  assetKeys: asset_keys,
  availability_end = null,
  downloadRequestKey: download_request_key = null,
  expires = false,
  internal = false,
  message = null,
  name = '',
  requestApproval: request_approval,
  requireIdentification: require_identification = false,
  viewOnly: view_only = false,
}) => (
  fetchJSON(url({ resourceKey, resourceType }), {
    method: 'POST',
    body: {
      data: {
        attributes: {
          asset_keys,
          availability_end,
          download_request_key,
          expires,
          internal,
          message,
          name,
          request_approval,
          require_identification,
          view_only,
        }
      }
    }
  }).catch(async (response) => { throw (await response.json()); })
);
